export enum PatientStatementActionType {
    ValidateStatement = 1,
    FinanceRelease = 2,
    ReOpen = 3,
    IssueBill = 4,
    OpenHaltStatements = 5,
    BlockOpenStatements = 6,
    UnBlockOpenStatements = 7
}
